import ServiceRequestAssignForm from 'src/pages/ServiceRequest/ServiceRequestAssignForm';
import { GenericDialogue } from 'src/components/Dialogue/Dialogue';
import NewBadge from 'src/components/NewBadge/NewBadge';
import Popup from './Popup';
import ServiceRequestScheduling from 'src/pages/ServiceRequest/ServiceRequestScheduling/ServiceRequestScheduling';
import ServiceRequestEditForm from 'src/components/ServiceRequestForm/ServiceRequestEditForm/ServiceRequestEditForm';

interface ServiceRequestOverlaysProps {
  serviceRequest: any;
  showEditOverlay: boolean;
  showAssignOverlay: boolean;
  showScheduleOverlay: boolean;
  showDeclinePopup: boolean;
  closeEditOverlay: () => void;
  closeAssignOverlay: () => void;
  closeScheduleOverlay: () => void;
  handleEditFormSaved: () => void;
  handleSaveScheduledAppointment: (
    formData: any,
    serviceRequestId: string
  ) => void;
  handleStatusAssign: (statusFormData: any, serviceRequestId: string) => void;
  onSubmitDeclinePopup: (type: string, data: any) => void;
}

const ServiceRequestOverlays = ({
  serviceRequest,
  showEditOverlay,
  showAssignOverlay,
  showScheduleOverlay,
  showDeclinePopup,
  closeEditOverlay,
  closeAssignOverlay,
  closeScheduleOverlay,
  handleEditFormSaved,
  handleSaveScheduledAppointment,
  handleStatusAssign,
  onSubmitDeclinePopup,
}: ServiceRequestOverlaysProps) => {
  if (!serviceRequest) {
    return showDeclinePopup ? (
      <Popup onSubmitPopup={onSubmitDeclinePopup} />
    ) : null;
  }

  return (
    <>
      <ServiceRequestEditForm
        isOpen={showEditOverlay}
        serviceRequest={serviceRequest}
        onClose={closeEditOverlay}
        onSaved={handleEditFormSaved}
        handleSaveScheduledAppointment={handleSaveScheduledAppointment}
        handleStatusChange={handleStatusAssign}
      />
      <GenericDialogue
        isOpen={showAssignOverlay}
        onClose={closeAssignOverlay}
        title={
          <>
            Assign Service Request
            <NewBadge spaced />
          </>
        }
        maxWidth="125rem"
        minHeight="95vh"
      >
        <ServiceRequestAssignForm
          serviceRequest={serviceRequest}
          onClose={closeAssignOverlay}
          handleStatusChange={handleStatusAssign}
          isLegacyTable={false}
          from={undefined}
        />
      </GenericDialogue>
      {showScheduleOverlay && (
        <ServiceRequestScheduling
          serviceRequest={serviceRequest}
          onClose={closeScheduleOverlay}
          onEventScheduled={(data: any) =>
            handleSaveScheduledAppointment(data, serviceRequest.id)
          }
        />
      )}
      {showDeclinePopup && <Popup onSubmitPopup={onSubmitDeclinePopup} />}
    </>
  );
};

export default ServiceRequestOverlays;
